import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { navFooterDetailLoad } from 'store/models/navFooter';
import { DetailLoadComponent } from 'components/common';

const NavFooterValue = (props) => {
  return (
    <DetailLoadComponent
      apiLoad={navFooterDetailLoad(props.site.activeDomain)}
      {...props}
      getDetailUrl={(id, item) => props.model.urls.detail(id)}
      render={({ id, item, linkPath }) => {
        const value = (item && item.title) || id;

        return (
          <Fragment>{props.asLink && linkPath ? <Link to={linkPath}>{value}</Link> : <span>{value}</span>}</Fragment>
        );
      }}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.navFooter,
  site: state.site,
});

export default connect(mapState)(NavFooterValue);
